var map = {
	"./ion-accordion_2.entry.js": [
		58029,
		2076,
		8029
	],
	"./ion-action-sheet.entry.js": [
		69808,
		2076,
		9808
	],
	"./ion-alert.entry.js": [
		6064,
		2076,
		6064
	],
	"./ion-app_8.entry.js": [
		22386,
		2076,
		2386
	],
	"./ion-avatar_3.entry.js": [
		57267,
		7267
	],
	"./ion-back-button.entry.js": [
		21464,
		2076,
		1464
	],
	"./ion-backdrop.entry.js": [
		28750,
		8750
	],
	"./ion-breadcrumb_2.entry.js": [
		8976,
		2076,
		8976
	],
	"./ion-button_2.entry.js": [
		88949,
		8949
	],
	"./ion-card_5.entry.js": [
		89918,
		9918
	],
	"./ion-checkbox.entry.js": [
		60965,
		2076,
		965
	],
	"./ion-chip.entry.js": [
		90198,
		198
	],
	"./ion-col_3.entry.js": [
		92445,
		4826
	],
	"./ion-datetime-button.entry.js": [
		88886,
		8579,
		8886
	],
	"./ion-datetime_3.entry.js": [
		51215,
		8579,
		2076,
		1215
	],
	"./ion-fab_3.entry.js": [
		27605,
		2076,
		7605
	],
	"./ion-img.entry.js": [
		86353,
		6353
	],
	"./ion-infinite-scroll_2.entry.js": [
		43213,
		2076,
		3213
	],
	"./ion-input.entry.js": [
		88010,
		2076,
		8010
	],
	"./ion-item-option_3.entry.js": [
		40695,
		2076,
		695
	],
	"./ion-item_8.entry.js": [
		67056,
		2076,
		7056
	],
	"./ion-loading.entry.js": [
		43022,
		2076,
		3022
	],
	"./ion-menu_3.entry.js": [
		24769,
		2076,
		4769
	],
	"./ion-modal.entry.js": [
		49563,
		2076,
		9563
	],
	"./ion-nav_2.entry.js": [
		48390,
		2076,
		8390
	],
	"./ion-picker-column-internal.entry.js": [
		74375,
		2076,
		4375
	],
	"./ion-picker-internal.entry.js": [
		2794,
		2794
	],
	"./ion-popover.entry.js": [
		85519,
		2076,
		5519
	],
	"./ion-progress-bar.entry.js": [
		61459,
		1459
	],
	"./ion-radio_2.entry.js": [
		19328,
		2076,
		9328
	],
	"./ion-range.entry.js": [
		76047,
		2076,
		6047
	],
	"./ion-refresher_2.entry.js": [
		13887,
		2076,
		3887
	],
	"./ion-reorder_2.entry.js": [
		38500,
		2076,
		8500
	],
	"./ion-ripple-effect.entry.js": [
		80554,
		554
	],
	"./ion-route_4.entry.js": [
		30780,
		780
	],
	"./ion-searchbar.entry.js": [
		35819,
		2076,
		5819
	],
	"./ion-segment_2.entry.js": [
		52858,
		2076,
		2858
	],
	"./ion-select_3.entry.js": [
		64942,
		2076,
		4942
	],
	"./ion-spinner.entry.js": [
		28875,
		2076,
		8875
	],
	"./ion-split-pane.entry.js": [
		79297,
		9297
	],
	"./ion-tab-bar_2.entry.js": [
		31656,
		2076,
		1656
	],
	"./ion-tab_2.entry.js": [
		74720,
		4720
	],
	"./ion-text.entry.js": [
		64555,
		4555
	],
	"./ion-textarea.entry.js": [
		79242,
		2076,
		9242
	],
	"./ion-toast.entry.js": [
		50477,
		2076,
		477
	],
	"./ion-toggle.entry.js": [
		96036,
		2076,
		6036
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73845;
module.exports = webpackAsyncContext;